import z from "zod";
import { userWithSecretsSchema } from "../user";
import { createZodDto } from "nestjs-zod/dto";
import { referencePeriodSchema } from "../reference-period";

export const referenceWithUserSchema = z.object({
  id: z.string(),
  upUser: userWithSecretsSchema,
  downUser: userWithSecretsSchema,
  periodId: z.string().nullable().optional(),
  period: referencePeriodSchema.optional().nullable(),
  status: z.enum(["opened", "closed"]),
});
export const referenceUserSchema = z.object({
  id: z.string(),
  upUserId: z.string(),
  downUserId: z.string(),
  periodId: z.string().optional(),
  period: referencePeriodSchema.optional(),
  status: z.enum(["opened", "closed"]),
});

export const createRefernceUserSchema = referenceUserSchema.pick({
  upUserId: true,
  downUserId: true,
});

export const filterReferenceUserSchema = referenceUserSchema.partial();

export class ReferenceUser extends createZodDto(referenceWithUserSchema) {}
export class CreateReferenceUser extends createZodDto(createRefernceUserSchema) {}

export type FilterReferenceUser = z.infer<typeof filterReferenceUserSchema>;
